import { DefaultState } from './ErrorMessageData'

export default function ErrroMessageReducer(state = DefaultState, action = {}) {
  return state
}
